<div class="max-h-full overflow-y-auto scroll-smooth">
  <div class="border-b border-blue-300 mb-3 sm:mb-4 px-3 sm:px-0">
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-0 p-3 sm:pb-1">
      <h1 class="text-base sm:text-xl md:text-2xl font-bold p-2 ml-0 sm:ml-2 text-black leading-tight">2. Extraction and
        Mapping</h1>
      <div>
        @if(!isRunningState) {
          <button [disabled]="selectedStates().length === 0" (click)="extractAll()"
            class="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 sm:py-2 px-4 rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer text-sm sm:text-sm shadow-md disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-gray-400 disabled:transform-none">
            Extract All
          </button>
        } @else {
          <button 
            (click)="stopExtraction()"
            class="w-full sm:w-auto bg-gray-600 text-white font-medium py-3 sm:py-2 px-4 rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 text-sm sm:text-sm shadow-md disabled:bg-gray-400 disabled:opacity-60 disabled:hover:bg-gray-400 disabled:transform-none">
            
            <span class="flex justify-center gap-2">
              @if(spinning) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              }
              Stop Extraction
            </span>
          </button>
        }
      </div>
    </div>
  </div>
  <div class="flex items-center gap-3 pl-5">
    <!-- <input type="checkbox" [checked]="selectedStates.length === states.length" [indeterminate]="selectedStates.length > 0 && selectedStates.length < states.length" (change)="selectAllStates()" class="ui-checkbox" /> -->
    <p-checkBox class="mb-1" [(ngModel)]="allChecks.allSelected" [indeterminate]="allChecks.indeterminate" [disabled]="isRunningState" (onChange)="selectAllStates($event)" [binary]="true"/>
    <span class="text-black text-sm font-poppins">
      @if(selectedStates().length === states.length) {
        Clear All
      } @else if(selectedStates().length > 0) {
        Clear Selected
      } @else {
        Select All
      }
    </span>

  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-6 justify-center px-2 sm:p-4">
    <!-- <ng-container *ngFor="let state of states"> -->
    @for(state of states; track state.name) {
    <div
      class="bg-gradient-to-br from-gray-800/80 to-gray-700/80 backdrop-blur-md border border-gray-600/30 rounded-xl sm:rounded-2xl shadow-lg p-4 sm:p-6 max-w-2xl h-auto sm:h-36 flex flex-col justify-between"
      [ngClass]="{'card-in-progress': getStateStatus(state.name) === 'in_progress'}">
      <div class="flex justify-between items-start mb-3 sm:mb-0">
        <div class="flex items-center space-x-2 mb-3 sm:mb-4">
          <input type="checkbox" [checked]="selectedStates().includes(state.name)" [disabled]="isRunningState"
            (change)="onStateCheckboxChange(state.name)" class="ui-checkbox" />
          <h2 class="text-base sm:text-lg md:text-xl font-semibold tracking-wide text-white">{{ state.name }}</h2>
        </div>
        <div
          class="px-2 sm:px-3 py-0.5 sm:py-1 rounded-full capitalize tracking-wide font-semibold text-lg sm:text-sm font-poppins flex-shrink-0"
          [ngClass]="{
            'text-gray-400': getStateStatus(state.name) === 'not_started',
            'text-yellow-400': getStateStatus(state.name) === 'in_progress',
            'text-green-500': getStateStatus(state.name) === 'completed',
            'text-red-500': getStateStatus(state.name) === 'failed'
            }">
          @if(getStateStatus(state.name) === 'not_started') {
          Not Started
          } @else if(getStateStatus(state.name) === 'in_progress') {
          In Progress
          } @else if(getStateStatus(state.name) === 'completed') {
          Completed
          } @else if(getStateStatus(state.name) === 'failed') {
          Failed
          } @else {
          Unknown
          }
        </div>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-0 sm:justify-between">
        <button (click)="viewDlg.toggleDialog()" [disabled]="isRunningState ? state.name !== currentState : false"
          class="w-full sm:w-auto bg-white hover:bg-gray-300 text-black font-medium text-xs sm:text-2xs py-2 sm:py-1 px-3 sm:px-2 rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer disabled:cursor-not-allowed border border-gray-400">
          <i class="pi pi-eye"></i>
          View / Validate
        </button>
        <button [disabled]="viewDlg.isRunningState" (click)="extract(state.name, null)"
          class="w-full sm:w-auto sm:ml-4 bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 sm:py-1 px-3 sm:px-2 rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer disabled:cursor-not-allowed text-xs sm:text-sm">
          Extract
        </button>
      </div>
    </div>
    <div class="absolute">
      <app-state-update-view #viewDlg [state]="state" (reRun)="extract($event.stateName, $event.userMsg)"></app-state-update-view>
    </div>
    }
    <!-- </ng-container> -->
  </div>
</div>


<p-dialog [(visible)]="dependencyDialogVisible" [focusOnShow]="false" [draggable]="false" [modal]="true"
  [resizable]="false"
  styleClass="z-[1000] py-0 rounded-2xl w-auto border-0 shadow-2xl shadow-blue-500/20 focus:outline-none backdrop-blur-sm bg-white/95">
  <ng-template #header>
    <div class="flex justify-center items-center w-full border-b border-gray-600/30 p-3">
      <span class="font-bold text-2xl text-gray-900">Dependency</span>
    </div>
  </ng-template>
  <div class="flex flex-col justify-center items-center gap-6 min-w-[500px] max-h-[75vh] text-gray-100 px-8 py-6">
    <div class="text-center">
      <p class="text-gray-900 text-lg font-semibold mb-2">The following states must be completed first:</p>
    </div>
    <div class="flex flex-col gap-2 w-full max-w-md">
      @for(dependency of dependencyDependencies; track dependency) {
      <div class="bg-gray-200 rounded-lg px-4 py-3 border border-gray-600/30 text-center">
        <span class="text-gray-900 font-medium">{{ dependency }}</span>
      </div>
      }
    </div>
    <button type="button" (click)="addDependentStates()"
      class="mt-2 px-6 py-3 font-semibold bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-lg transition-all duration-200 hover:scale-105">
      Continue
    </button>
  </div>
</p-dialog>
